import React from 'react';
import {readFile, utils} from 'xlsx';

import './fileimport.css'

export default function FileImport(props){
	const changeHandler = (event) => {
		//setSelectedFile(event.target.files[0]);
		const selected = event.target.files[0]
		if (selected) {
			if (selected.name.toLowerCase().endsWith(".xlsx")) {
				handleXLSXFile(selected)
			}
			else 
				handleCSVFile(selected);
		}
		// reset the input element
		event.target.value = ''
	}
	const handleData = props.controller ?? (()=>{})
	const handleCSVFile = (fileObj) => {
		const reader = new FileReader();
		reader.onload = (event) => {
			const json = csv_to_json(event.target.result)
			handleData(json)
		}
		reader.onerror = (event) => {
			alert(event.target.error.name);
		};
		reader.readAsText(fileObj);
	};

	const csv_to_json = (csv) => {
		const lines = csv.split(/\r\n|\n/)
		const keys = lines.shift().split(',').map(string => string.trim())
		const result = lines.map (line => line_to_obj(keys, stripFormula(line.split(','))))
		return result
	}
	const stripFormula = (values) => {
		return values.map(v => v.startsWith("=\"") ? v.replace("=\"", '').slice(0, -1): v)
	}
	const line_to_obj = (keys, values) => {
		const entries = keys.map((k, index) => [k, values[index]])
		return Object.fromEntries(entries)
	}
	const handleXLSXFile=(fileObj) => {
		console.log ("do new stuff")
		const reader = new FileReader();
		reader.onload = (event) => {
			const data = event.target.result;
			const workbook = readFile(data, {type: "binary"});
			const sheet = workbook.Sheets[workbook.SheetNames[0]];
			const jsonData = utils.sheet_to_json(sheet);
			fix_xlsx_dates (jsonData)
			handleData(jsonData)
			console.log(jsonData);
		};
		reader.readAsArrayBuffer(fileObj);
	}
  const fix_xlsx_dates = (jsonData) => {
		const fixed = jsonData.map (item => {
			if ('number' === typeof item['Initial Meter Time']) {
				const excel_base = new Date('1899-12-31T00:00:00Z')
				addDays (excel_base, item['Initial Meter Time'] -1)
				item['Initial Meter Time'] = excel_base
			}
			return item
		})
		return fixed
	}
	function addDays (date, days) {
    return date.setDate(date.getDate() + days);
  }
	return(
   <div className='noheight'>
			<input className='noheight' type="file" name="file" id="fileImport" 
				accept=".csv, .xlsx" onInput={changeHandler} onChange={changeHandler}/>
		</div>
	)
}
